import React, { Component } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { Cookies } from 'react-cookie';
import Orders from './Orders';
import PrivateRoute from './PrivateRoute';
import SignIn from './SignIn';
import routerMap from '../constants/routerMap';
import Splash from '../components/Splash';
import Layout from '../components/Layout';
import ModalRedux from '../components/ModalRedux';
import { ErrorModal, HelpModal, LaunchingPanel } from '../components';

import {
  initializeApp,
  initializeSentry,
  getFirebaseCredentials,
  listenAuth
} from '../apis/firebase';
import * as actions from '../actions'

class AppRouter extends Component {
  async componentDidMount() {
    const shopId = new Cookies().get('shopId');
    if (shopId) {
      await getFirebaseCredentials(shopId)
      await initializeSentry()
      await initializeApp()
      listenAuth(shopId)
    } else {
      this.props.intializingData(false);
    }
  }

  render() {
    const { link, isOpen, showHelpModal, isAuthenticated } = this.props;
    return (
      <Router>
        <div className="theme-light ltr-support">
          {isAuthenticated ? (
            <div>
              <Layout />
              <div className="container__wrap">
                <LaunchingPanel />
                <Switch>
                  {routerMap.map(e => (
                    <PrivateRoute
                      path={e.path}
                      isAuthenticated={this.props.isAuthenticated}
                      component={e.component}
                      key={e}
                      exact={e.exact}
                      {...this.props}
                    />
                  ))}
                  <PrivateRoute
                    path="/"
                    isAuthenticated={this.props.isAuthenticated}
                    component={Orders}
                  />
                </Switch>
              </div>
            </div>
          ) : this.props.isInitializing ? (
            <Splash />
          ) : (
            <SignIn />
          )}
          <ModalRedux />
          <ErrorModal propsForActions={this.props} />
          <HelpModal
            isOpen={isOpen}
            link={link}
            handleClose={() => showHelpModal(null)}
            onClick={() => showHelpModal(null)}
          />
        </div>
      </Router>
    );
  }
}

function mapStateToProps({ user, firebaseRealTime }) {
  const { isAuthenticated, isInitializing, dataHelpModal = {}, isAllShops, shopId } = user;
  const { generalConfig } = firebaseRealTime;
  const { link, isOpen } = dataHelpModal;
  return {
    isAuthenticated,
    isInitializing,
    isOpen,
    link,
    generalConfig,
    isAllShops,
    shopId
  };
}

export default connect(mapStateToProps, actions)(AppRouter);
